module.exports = __webpack_public_path__ + "static/media/watershed.fa520a8c.png";